import helpers from '@/library/geolocation/services/providers/lexisNexis/helpers'
import store from '@/store'
import config from '@/config'

const state = config.app.autoconf.STATE.toUpperCase()

/**
 * LexisNexis geolocation provider implementation.
 * Provides methods for initializing, validating and managing
 * the LexisNexis geolocation process.
 */
class LexisNexis {
  /**
   * Initializes the geolocation process with LexisNexis.
   *
   * @async
   * @param {string} userID - Unique identifier of the user.
   * @param {string} sessionId - Current session identifier.
   * @param {string} reason - Reason for initialization (login, ip changed).
   * @returns {Promise<Object>} - Geolocation initialization response.
   * @throws {Error} - Throws if initialization fails.
   */
  async initGeolocation (userID, sessionId, reason) {
    try {
      return helpers.startGeolocation(userID, sessionId, reason)
    } catch (error) {
      throw error
    }
  }
  /**
   * Validates the provided geolocation data with LexisNexis.
   *
   * @async
   * @param {Object} geoPacket - Location data to be validated.
   * @param {string} userID - Unique identifier of the user.
   * @param {string} attemptId - Unique identifier of the attempt.
   * @returns {Promise<Object>} - Validation result object.
   * @throws {Error} - Throws if validation fails.
   */
  async validateGeolocation (geoPacket, userID, attemptId) {
    try {
      const response = await store.dispatch('geolocationSubmit', { geoPacket, state, attemptId })
      helpers.validateResponse(response.result, userID, false)
      return { validate: response.result }
    } catch (error) {
      throw error
    }
  }

  /**
   * Continues the geolocation process if additional steps are required.
   *
   * @async
   * @returns {Promise<Object>} - Continuation result.
   * @throws {Error} - Throws if continuation fails.
   */

  async continueGeolocation () {
    try {
      return helpers.continueGeolocationProcess()
    } catch (error) {
      throw error
    }
  }
  /**
   * Downloads the LexisNexis geolocation plugin (Radar Verify app).
   *
   * @async
   * @returns {Promise<Object>} - Plugin download result.
   * @throws {Error} - Throws if download fails.
   */
  async downloadPlugin () {
    try {
      return helpers.downloadPlugin()
    } catch (error) {
      throw error
    }
  }
  /**
   * Disconnects and stops polling the LexisNexis geolocation service.
   *
   * @async
   * @returns {Promise<Object>} - Service disconnection result.
   * @throws {Error} - Throws if disconnection fails.
   */
  async disconnectService () {
    try {
      return helpers.disconnectService()
    } catch (error) {
      throw error
    }
  }
}

export default LexisNexis



// WEBPACK FOOTER //
// ./src/library/geolocation/services/providers/lexisNexis/index.js